/* eslint-disable react/jsx-props-no-spreading */
import React, { useId } from 'react';
import { twMerge } from 'utilities/src/twMerge';

import { IInputTextareaProps } from './_props';

import { TFormField } from '../../shared/utils/types';

import { LabelTop, MessageError, MessageHelper, Field } from '../../shared/components';

import useInputTextareaTheme from './themes';

function InputTextarea<TFormFields extends TFormField = TFormField>({
  name,
  label = '',
  labelPosition = 'Top',
  errorMessage = '',
  errorIcon = undefined,
  errorClassName = '',
  helperMessage = '',
  placeholder = '',
  rows = 3,
  state = 'Default',
  theme = 'Light',
  variant = 'Secondary',
  size = 'Medium',
  stateIcon = undefined,
  required = false,
  value = '',
  className = '',
  fieldClassName = '',
  register,
  rules,
  onBlur,
  onChange,
  onKeyDown,
  maxLength,
  tabIndex,
  errorSpace = false,
  labelClassName,
}: IInputTextareaProps<TFormFields>) {
  const { inputTextareaWrapperCommonClasses, inputLabelWrapperThemeClasses, inputTextareaCommonClasses } =
    useInputTextareaTheme({
      inputState: state,
    });

  const id = useId();

  return (
    <div className={twMerge(inputTextareaWrapperCommonClasses, className)}>
      <label htmlFor={id} className={inputLabelWrapperThemeClasses}>
        <LabelTop
          size={size}
          id={id}
          label={label}
          labelPosition={labelPosition}
          theme={theme}
          required={required}
          labelClassName={labelClassName}
        />

        <Field
          type="Textarea"
          id={id}
          state={state}
          theme={theme}
          variant={variant}
          size={size}
          label={label}
          labelPosition={labelPosition}
          value={value}
          stateIcon={stateIcon}
          required={required}
          className={fieldClassName}
        >
          <textarea
            className={inputTextareaCommonClasses}
            name={name}
            aria-label={name}
            id={id}
            value={value}
            onBlur={onBlur}
            onChange={onChange}
            onKeyDown={onKeyDown}
            rows={rows}
            maxLength={maxLength}
            tabIndex={tabIndex}
            {...(labelPosition === 'Top' && { placeholder })}
            {...(register &&
              register(name, {
                onChange,
                onBlur,
                ...rules,
              }))}
          />
        </Field>
      </label>

      <MessageError
        message={errorMessage}
        icon={errorIcon}
        state={state}
        theme={theme}
        className={errorClassName}
        errorSpace={errorSpace}
      />

      <MessageHelper message={helperMessage} state={state} theme={theme} />
    </div>
  );
}

export default InputTextarea;
